<template>
  <v-container v-if="bookingContext">

      <BookingHeader :bookingContext="bookingContext"/>

    <!--TODO, get informations -->
      <p>

            <span>{{loggedUser.sexe | initial}}</span> <span class="bold">{{loggedUser.firstName}} {{loggedUser.lastName}}</span>,
        {{$t('booking.confirmation.thank_u_note')}} <b style="color:darkgreen;"> SB-{{bookingContext.number}}</b>

      <br>
      </p>
      <span class="bold">{{$t('booking.confirmation.confirmation_mail')}} :</span> {{loggedUser.email}}


      <h1 class="contacts-title">{{$t('booking.confirmation.contacts')}} : {{bookingContext.availabilityCar.tenantName}} </h1>
      <hr>
      <p>
          <span class="bold">{{$t('booking.confirmation.address')}} :</span><b>({{bookingContext.availabilityCar.agency.name}}) </b> {{bookingContext.availabilityCar.agency.address}}  <br>
          <span class="bold">{{$t('booking.confirmation.tel')}} :</span>{{bookingContext.availabilityCar.agency.phoneNumbers}}
          <br>
          <span class="bold">{{$t('booking.confirmation.email')}} :</span> <a :href="`mailto:${bookingContext.availabilityCar.agency.emails}`"> {{bookingContext.availabilityCar.agency.emails}}</a>
      </p>

      <v-btn class="primary" v-on:click="validateAndSubmit()">{{$t('shared.go_home_btn_label')}}</v-btn>

  </v-container>
</template>

<script>
import {BookingHeader} from '../components';
import { mapGetters } from 'vuex'

export default {
    name: 'BookingConfirmationStep',
    props: {
        bookingContext: null
    },
    methods: {
        validateAndSubmit(){
          this.$store.commit('booking/setContext', null);
            this.$emit('nextStep', this.bookingContext);
        }
    },
  computed: {
    ...mapGetters({ loggedUser: 'main/loggedUser' })
  },
    components: { BookingHeader }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .bold{
    font-weight: 600;
  }
  hr{
    margin-bottom: 1rem;
  }
  .contacts-title{
    margin-top: .7rem;
    font-size: 1.4rem;
  }
  .padding{
    padding: 2.5rem;
  }
</style>
